import theme from '../../../theme'
import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingTop: 5,
        paddingBottom: 20,
        backgroundColor: '#fff',
    },
    overlay: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: 'rgba(249, 246, 246, 0.71)', // Gris semi-transparente
        zIndex: 1,
    },
    blockHeader: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingHorizontal: 10,
        paddingTop: 4,
    },
    imageHeader: {
        width: 20,
        aspectRatio: 1,
        marginRight: 10,
        marginTop: 5,
        borderRadius: 4,
    },
    imageHeaderList: {
        width: 150,
        aspectRatio: 1,
        marginHorizontal: 10,
        borderRadius: 5,
    },
    namesCategory: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'space-between',
        marginBottom: 12,
    },
    containerCategoryName: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    containerCategoryNameBis: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    categoryName: {
        fontSize: 20,
        fontWeight: 'bold',
        marginRight: 5,
        color: theme.colors.textPrimary,
    },
    categoryNameBis: {
        flex: 1,
        fontSize: 20,
        fontWeight: 'bold',
        marginRight: 12,
        color: theme.colors.textPrimary,
    },
    categoryDescription: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
    },
    categoryDescriptionList: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        marginTop: 4,
        marginHorizontal: 12,
        marginBottom: 12,
    },
    seeMoreText: {
        fontSize: 14,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
        textAlign: 'right',
        marginHorizontal: 12,
        position: 'relative',
        top: -15,
    },
    spacer: {
        height: 4,
    },
    spacer1: {
        height: 12,
    },
})

export default styles
